import { deleteKeysObject, exists, removeDBObjectKeys, tsValidateArray, tsValidateBoolean, tsValidateOptional, tsValidateOptionalId, tsValidateRegexp, tsValidateResult, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { perspectives, variableType_Attribute, variableType_AttributeInstance, variableType_EvidenceOf, variableType_FamilyHistoryOf, variableType_HistoryOf, variableType_Normal, variableType_PrecipitatingFactor, variableType_Recent, variableType_RelievingFactor } from './types.js';
import { Validator_TagGroup } from '../macro-tag/db-def.js';
import { knowledgeManagerDBGroup } from '../common.js';
const Validator_VariableCore = {
    name: tsValidateRegexp(/^[A-Za-zÀ-ÖØ-öø-ÿ\d\-+:'.&/ ]{2,200}$/),
    perspective: tsValidateValue([...perspectives]),
    nlpDataId: tsValidateOptionalId,
    showInAdvisor: tsValidateBoolean(),
    tagIds: tsValidateArray(Validator_TagGroup),
    valueId: tsValidateUniqueId,
    referenceIds: tsValidateArray(tsValidateUniqueId, false),
    otherProperties: tsValidateOptional,
    attributes: tsValidateArray({ varId: tsValidateUniqueId, valueId: tsValidateUniqueId }, false),
    inRangeExpression: tsValidateOptionalId
};
const Validator_VariableNormal = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_Normal]),
};
const Validator_VariableAttribute = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_Attribute]),
};
const Validator_VariableAttributeInstance = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_AttributeInstance]),
    parents: {
        variableId: tsValidateUniqueId,
        attributeId: tsValidateUniqueId,
    }
};
const Validator_VariableAttributeRelievingFactor = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_RelievingFactor]),
    variableInfo: {
        variableId: tsValidateUniqueId,
        valueId: tsValidateUniqueId
    }
};
const Validator_VariableAttributePrecipitatingFactor = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_PrecipitatingFactor]),
    variableInfo: {
        variableId: tsValidateUniqueId,
        valueId: tsValidateUniqueId
    }
};
const Validator_Variable_HistoryOf = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_HistoryOf]),
    parentId: tsValidateUniqueId,
};
const Validator_Variable_FamilyHistoryOf = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_FamilyHistoryOf]),
    parentId: tsValidateUniqueId,
};
const Validator_Variable_EvidenceOf = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_EvidenceOf]),
    parentId: tsValidateUniqueId,
};
const Validator_Variable_Recent = {
    ...Validator_VariableCore,
    type: tsValidateValue([variableType_Recent]),
    parentId: tsValidateUniqueId,
};
export const Validator_ModifiableProps = (instance) => {
    if (!exists(instance))
        return 'Was not given a variable to validate';
    // @ts-ignore
    const toValidate = deleteKeysObject(removeDBObjectKeys(instance), DBDef_Variable.generatedProps);
    switch (instance.type) {
        case variableType_Normal:
            return tsValidateResult(toValidate, Validator_VariableNormal);
        case variableType_Attribute:
            return tsValidateResult(toValidate, Validator_VariableAttribute);
        case variableType_AttributeInstance:
            return tsValidateResult(toValidate, Validator_VariableAttributeInstance);
        case variableType_PrecipitatingFactor:
            return tsValidateResult(toValidate, Validator_VariableAttributePrecipitatingFactor);
        case variableType_RelievingFactor:
            return tsValidateResult(toValidate, Validator_VariableAttributeRelievingFactor);
        case variableType_HistoryOf:
            return tsValidateResult(toValidate, Validator_Variable_HistoryOf);
        case variableType_FamilyHistoryOf:
            return tsValidateResult(toValidate, Validator_Variable_FamilyHistoryOf);
        case variableType_EvidenceOf:
            return tsValidateResult(toValidate, Validator_Variable_EvidenceOf);
        case variableType_Recent:
            return tsValidateResult(toValidate, Validator_Variable_Recent);
        default:
            // @ts-ignore
            return `No validator implemented for variable with type ${toValidate.type}`;
    }
};
const Validator_GeneratedProps = {
    _nameInLowercase: tsValidateRegexp(/^[A-Za-zÀ-ÖØ-öø-ÿ\d\-+:'.&/ ]{2,200}$/),
    _tagIds: tsValidateArray(tsValidateUniqueId),
    _rowId: tsValidateOptionalId,
    _attributeVarIds: tsValidateArray(tsValidateString(), false),
    _attributeValueIds: tsValidateArray(tsValidateString(), false),
    _attributeParentsIds: tsValidateArray(tsValidateUniqueId, false)
};
export const DBDef_Variable = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    generatedProps: ['_nameInLowercase', '_tagIds', '_rowId', '_attributeVarIds', '_attributeValueIds', '_attributeParentsIds'],
    versions: ['1.0.6', '1.0.5', '1.0.4', '1.0.3', '1.0.2', '1.0.1', '1.0.0'],
    dbKey: 'variables',
    entityName: 'Variable',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'variable'
    },
    backend: {
        name: 'variables'
    },
    dependencies: {
        'nlpDataId': { dbKey: 'nlp-data', fieldType: 'string' },
        'valueId': { dbKey: 'values', fieldType: 'string' },
        'referenceIds': { dbKey: 'references', fieldType: 'string[]' },
        '_tagIds': { dbKey: 'tags', fieldType: 'string[]' },
        '_attributeVarIds': { dbKey: 'variables', fieldType: 'string[]' },
        '_attributeValueIds': { dbKey: 'values', fieldType: 'string[]' },
        '_attributeParentsIds': { dbKey: 'variables', fieldType: 'string[]' }
    }
};
//# sourceMappingURL=db-def.js.map